import request from '@/utils/request'

// 创建助播(仅主播调用,当前直播间没有才可以创建)
export function createHelpLive(data) {
  return request({
    url: '/app-api/service/helpLive/createHelpLive/v1_0_0',
    method: 'post',
    data: data
  })
}
//获取直播间的助播配置信息(仅主播调用)
export function getAppHelpLiveConfig(query) {
  return request({
    url: '/app-api/service/helpLive/getAppHelpLiveConfig/v1_0_0',
    method: 'get',
    params: query
  })
}
// 踢出助播(仅主播)
export function kickOutHelp(data) {
  return request({
    url: '/app-api/service/helpLive/kickOutHelp/v1_0_0',
    method: 'post',
    data: data
  })
}
// 修改助播配置(全局场控,仅主播调用,支持单个字段修改)
export function updateHelpLiveConfig(data) {
  return request({
    url: '/app-api/service/helpLive/updateHelpLiveConfig/v1_0_0',
    method: 'post',
    data: data
  })
}
//获取直播间已加入的助播列表(和直播间详情返回一致,不用登录)
export function getHelpUserList(query) {
  return request({
    url: '/app-api/service/helpLive/getHelpUserList/v1_0_0',
    method: 'get',
    params: query
  })
}
//获取某个助播详情(不用登录)
export function getHelpUserInfo(query) {
  return request({
    url: '/app-api/service/helpLive/getHelpUserInfo/v1_0_0',
    method: 'get',
    params: query
  })
}
// 修改某个助播信息(仅主播,支持单个字段修改)
export function updateHelpLiveUser(data) {
  return request({
    url: '/app-api/service/helpLive/updateHelpLiveUser/v1_0_0',
    method: 'post',
    data: data
  })
}
//获取助播金钥详情(用户加入前使用,不用登录)
export function getHelpKeyInfo(query) {
  return request({
    url: '/app-api/service/helpLive/getHelpKeyInfo/v1_0_0',
    method: 'get',
    params: query
  })
}
// 加入助播
export function joinHelpLive(data) {
  return request({
    url: '/app-api/service/helpLive/joinHelpLive/v1_0_0',
    method: 'post',
    data: data
  })
}
// 自己退出助播
export function exitHelp(data) {
  return request({
    url: '/app-api/service/helpLive/exitHelp/v1_0_0',
    method: 'post',
    data: data
  })
}
// 助播自己修改摄像头状态
export function updateCameraStatus(data) {
  return request({
    url: '/app-api/service/helpLive/updateCameraStatus/v1_0_0',
    method: 'post',
    data: data
  })
}
// 助播自己修改麦克风状态
export function updateMicrophoneStatus(data) {
  return request({
    url: '/app-api/service/helpLive/updateMicrophoneStatus/v1_0_0',
    method: 'post',
    data: data
  })
}
//获取直播背景配置列表(无需登录)
export function getLiveBgList(query) {
  return request({
    url: '/app-api/service/live/getLiveBgList/v1_0_0',
    method: 'get',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/api/zhubo.js